import { render, staticRenderFns } from "./myNotify.vue?vue&type=template&id=27478f50&"
import script from "./myNotify.vue?vue&type=script&lang=js&"
export * from "./myNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports